import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import {AlertColor} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppRootState } from '../../app/store';
import { setAppErrorAC } from '../../app/app-reducer';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function ErrorSnackBar() {
  // const [open, setOpen] = React.useState(true);
  const error = useSelector<AppRootState, string | null>(state => state.app.error)
  const color = useSelector<AppRootState, AlertColor>(state => state.app.color)
  const dispatch = useDispatch()

  const isOpen = error !== null

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setAppErrorAC({error: null, color:'error'}))
    //setOpen(false);
  }
  return (
    <Snackbar anchorOrigin={ {vertical:'bottom', horizontal:'right'} } open={isOpen} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
        {error}
      </Alert>
    </Snackbar>
  );
}